module.exports = __webpack_public_path__ + "img/success.b55930ae.svg";